import {
  addMcBasicDetails,
  getAccountStatus
} from "../../api.resource/api/root";

const state = {
  loading: false,
  mcAccountStatus: null,
  mcAccountStatusSuccess: null,
  mcAccountStatusMsg: null,
  mcProfileDetails: null
  // mcDataSuccess: false,
  // mcDataMsg: null,
  // mcLicenseSuccess: false,
  // mcLicenseMsg: null
};

const getters = {
  loading: state => state.loading,
  mcAccountStatus: state => state.mcAccountStatus,
  mcAccountData: state => state.mcAccountData,
  mcDataSuccess: state => state.mcDataSuccess,
  mcDataMsg: state => state.mcDataMsg,
  mcProfileDetails: state => state.mcProfileDetails
};

const actions = {
  async GET_ACCOUNT_STATUS({ commit }, payload) {
    commit("LOADING");
    let accountStatus = await getAccountStatus(payload);

    if (accountStatus?.result?.MCProfileDetails) {
      commit("MC_PROFILE_DETAILS", accountStatus?.result?.MCProfileDetails);
    }

    if (accountStatus?.success === true) {
      commit("ACCOUNT_STATUS_SUCCESS", accountStatus);
    } else {
      commit("ACCOUNT_STATUS_ERROR", accountStatus);
    }

    commit("LOADING_STOP");
  }
  // async ADD_MC_DATA({ commit }, payload) {
  //   commit("RESET_ADD_MC_DATA");
  //   commit("LOADING");
  //   let addMcData = await addMcBasicDetails(payload);

  //   if (addMcData?.success === true) {
  //     commit("ADD_MC_DATA_SUCCESS", addMcData);
  //   } else {
  //     commit("ADD_MC_DATA_ERROR", addMcData?.message);
  //   }
  // }
};

const mutations = {
  LOADING(state) {
    state.loading = true;
  },
  LOADING_STOP(state) {
    state.loading = false;
  },
  ACCOUNT_STATUS_SUCCESS(state, payload) {
    state.loading = false;
    state.mcAccountStatusSuccess = true;
    if (payload.result !== undefined) {
      state.mcAccountStatusMsg = payload.Description;
      state.mcAccountStatus = payload.result.data;
    } else {
      state.mcAccountStatus = null;
    }
  },
  ACCOUNT_STATUS_ERROR(state, payload) {
    state.loading = false;
    state.mcAccountStatusSuccess = false;
    state.mcAccountStatusMsg = payload?.Description;
    state.mcAccountStatus = null;
  },
  RESET_ACCOUNT_STATUS(state) {
    state.loading = false;
    state.mcAccountStatusSuccess = false;
    state.mcAccountStatusMsg = null;
    state.mcAccountStatus = null;
  },
  MC_PROFILE_DETAILS(state, payload) {
    state.mcProfileDetails = payload;
  }
  // ADD_MC_DATA_SUCCESS(state, payload) {
  //   state.loading = false;
  //   state.mcDataSuccess = true;
  //   state.mcDataMsg = payload;
  // },
  // ADD_MC_DATA_ERROR(state, payload) {
  //   state.loading = false;
  //   state.mcDataSuccess = false;
  //   state.mcDataMsg = payload;
  // },
  // RESET_ADD_MC_DATA(state) {
  //   state.loading = false;
  //   state.mcDataSuccess = false;
  //   state.mcDataMsg = null;
  // }
};

export default {
  namespaced: true,
  state: () => ({ ...state }),
  getters,
  actions,
  mutations
};
